import { useMutation, useQuery, useQueryClient } from 'react-query';
import * as api from '../../services/api';

const HELP_DESK_ACCOUNT_SETTINGS_QUERY_KEY = 'helpDeskAccountSettings';
export const getHelpDeskAccountSettingsQueryKey = (accountId) => [
  HELP_DESK_ACCOUNT_SETTINGS_QUERY_KEY,
  String(accountId)
];

/**
 * Account-level help-desk settings (resolution confirmation message + auto-close timeout hours).
 * Returns the current settings and a mutation to update them.
 * @param {Object} params
 * @param {string|number} params.accountId
 */
const useHelpDeskAccountSettings = ({ accountId }) => {
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery(
    getHelpDeskAccountSettingsQueryKey(accountId),
    () => api.fetchHelpDeskAccountSettings({ accountId }),
    { enabled: !!accountId }
  );

  const { mutate: updateSettings, mutateAsync: updateSettingsAsync, isLoading: isUpdating } = useMutation(
    (body) => api.updateHelpDeskAccountSettings({ accountId, ...body }),
    {
      onSuccess: () => queryClient.invalidateQueries(getHelpDeskAccountSettingsQueryKey(accountId))
    }
  );

  return {
    settings: data?.data ?? null,
    isLoading,
    updateSettings,
    updateSettingsAsync,
    isUpdating
  };
};

export default useHelpDeskAccountSettings;
